import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../Icon/Icon';

/**
 * Floating Action Button for quick booking access
 * 
 * @param {string} icon - Icon name
 * @param {string} to - Navigation path
 * @param {function} onClick - Click handler
 */
const FloatingActionButton = ({
  icon = 'calendar_month',
  to = '/enquiry',
  onClick,
  className = '',
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    }
  };

  return (
    <button
      onClick={handleClick}
      style={{ 
        position: 'fixed',
        bottom: 'max(24px, env(safe-area-inset-bottom, 24px))',
        right: '24px',
      }}
      className={`
        z-[9999]
        flex h-14 w-14 items-center justify-center rounded-full 
        bg-primary text-white shadow-lg shadow-primary/40 
        transition-all active:scale-95 
        hover:bg-neon-pink hover:shadow-neon-pink/40
        ${className}
      `}
      aria-label="Book a show"
    >
      <Icon name={icon} size="lg" />
    </button>
  );
};

export default FloatingActionButton;
